<template>
  <div class="floating-menu-container">
    <div class="floating-menu py-1 px-2">
      <v-menu
        v-model="menu"
        content-class="menu-container mb-3"
        top
        center
        offset-y
        elevation="0"
      >
        <template v-slot:activator="{on}">
          <StoryCityGradientButton
            :on="on"
            class="rounded-xl rounded-button mr-5 px-5 py-2"
            depressed
            color1="primary"
            color2="primaryDark"
            @click="menu = !menu"
          >
            <v-icon class="mr-2">$plus</v-icon>
            {{ $t("chapter.addContent") }}
          </StoryCityGradientButton>
        </template>
        <v-list class="option-container px-1 py-3">
          <v-list-item>
            <v-btn
              class="content-option-button px-5 py-2"
              @click="addAudio"
              color="primaryLight"
              block
              depressed
            >
              <div>
                <v-icon :size="largeIconSize" class="mr-2">$musicNote</v-icon>
                {{ $t("chapter.audio.audioTrack") }}
              </div>
              <div class="letter-indicator">A</div>
            </v-btn>
          </v-list-item>
          <v-list-item>
            <v-btn
              class="content-option-button px-5 py-2"
              @click="addVideo"
              color="primaryLight"
              block
              depressed
            >
              <div>
                <v-icon :size="largeIconSize" class="mr-2">$video</v-icon>
                {{ $t("chapter.video.videoFrame") }}
              </div>
              <div class="letter-indicator">V</div>
            </v-btn>
          </v-list-item>
          <v-list-item>
            <v-btn
              class="content-option-button px-5 py-2"
              @click="addImage"
              color="primaryLight"
              block
              depressed
            >
              <div>
                <v-icon :size="largeIconSize" class="mr-2">$image</v-icon>
                {{ $t("chapter.image.image") }}
              </div>
              <div class="letter-indicator">I</div>
            </v-btn>
          </v-list-item>
          <div class="triangle" />
        </v-list>
      </v-menu>
      <v-btn
        class="px-4 py-2"
        color="background"
        depressed
        @click="resetZoom"
      >
        <span class="reset-zoom-text">{{ $t("chapter.zoom100") }}</span>
      </v-btn>
      <v-btn
        class="zoom-button pa-3 mx-3"
        color="secondaryBackground"
        fab
        depressed
        @click="decrementZoom"
      >
        <v-icon color="primary" size="22px">$zoomOut</v-icon>
      </v-btn>
      <v-btn
        class="zoom-button pa-3"
        color="secondaryBackground"
        fab
        depressed
        @click="incrementZoom"
      >
        <v-icon color="primary" size="22px">$zoomIn</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import StoryCityGradientButton from "@/components/Buttons/StoryCityGradientButton.vue";

const START_ZOOM = 2;
const MAX_ZOOM = 10;
const ADD_CONTENT_ICON_SIZE = 24;
export default {
  components: {
    StoryCityGradientButton,
  },
  props: {
    editor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      menu: false,
      zoomLevel: START_ZOOM,
    };
  },
  computed: {
    largeIconSize() {
      return ADD_CONTENT_ICON_SIZE;
    },
  },
  methods: {
    incrementZoom() {
      if (this.zoomLevel == MAX_ZOOM) {
        return;
      }
      this.zoomLevel = this.zoomLevel + 1;
    },
    decrementZoom() {
      if (this.zoomLevel == 1) {
        return;
      }
      this.zoomLevel = this.zoomLevel - 1;
    },
    resetZoom() {
      this.zoomLevel = START_ZOOM;
    },
    addImage() {
      this.editor
        .chain()
        .focus()
        .setTextSelection(this.editor.state.selection.to)
        .setImage({ src: null })
        .run();
    },
    addAudio() {
      this.editor
        .chain()
        .focus()
        .setTextSelection(this.editor.state.selection.to)
        .setAudio()
        .run();
    },
    addVideo() {
      this.editor
        .chain()
        .focus()
        .setTextSelection(this.editor.state.selection.to)
        .setVideo()
        .run();
    },
  },
  watch: {
    zoomLevel: function (newValue) {
      this.$emit("zoom", newValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.floating-menu-container {
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  bottom: 10px;
  z-index: 1;
}

.floating-menu {
  border-radius: 58px;
  border: 1.333px solid var(--v-primaryFaded-base);
  background-color: #D2EDFD;
  display: inline-block;
}

.zoom-button {
  height: 48px;
  width: 48px;
}

.reset-zoom-text {
  color: var(--v-textOnAccent-base);
}

.v-btn.content-option-button {
  width: 264px;
  display: flex;
  justify-content: space-between;
  color: var(--v-textOnPrimary-base);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
}

::v-deep.v-btn.content-option-button .v-btn__content {
  line-height: 28px;
}

.letter-indicator {
  width: 10px;
  text-align: center;
}

.menu-container {
  background: transparent;
  box-shadow: none;
  overflow: visible;
  contain: none;
}

.v-list.option-container {
  // center list relative to button size
  position: relative;
  bottom: 12px;
  left: -67px;
  border-radius: 20px;
  background: var(--v-secondaryBackground-base);
  box-shadow: 4px 7px 17px 0px rgba(0, 0, 0, 0.12) !important;
}

.triangle {
  // css triangle pointing down
  position: absolute;
  bottom: -12px;
  left: 50%;
  margin-left: -12px;
  width: 0;
  height: 0;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-top: 12px solid var(--v-secondaryBackground-base);
}
</style>
